import { commitLocalUpdate } from 'react-relay';

import { get } from 'lodash';
import { put, takeEvery } from 'redux-saga/effects';
import { createAsyncAction, getType } from 'typesafe-actions';
import { LoggerStatusEnum, sendLog } from 'ui-model';

import environment from '@lib/utils/RelayEnvironment';

import { updateFetchKeyDelayed } from 'actions';
import { toGlobalId } from 'services/relayService';

export const actionReminderSend = createAsyncAction(
  'actionReminderSend/REQUEST',
  'actionReminderSend/SUCCESS',
  'actionReminderSend/FAILURE',
)<any, any, any>();

const typeName = 'Reminder';

function* sagaWatcher(action: any) {
  try {
    yield put(updateFetchKeyDelayed(typeName));

    const reminder = get(action, 'payload.data');
    const _id = get(reminder, '_id');
    if (!_id) {
      sendLog('sagaWatchersReminder', { error: '_id missing', action }, LoggerStatusEnum.error);
      return;
    }

    commitLocalUpdate(environment, (store) => {
      const record = store.get(toGlobalId(typeName, _id));
      if (!record) {
        return;
      }
      record.setValue(reminder.sendAt, 'sendAt');
      record.setValue(reminder.status, 'status');
    });

    yield put(updateFetchKeyDelayed(typeName));
  } catch (error) {
    sendLog('sagaWatchersReminder', { error, action }, LoggerStatusEnum.error);
  }
}

export default function* sagaWatchersReminder() {
  yield takeEvery(getType(actionReminderSend.success), sagaWatcher);
}
